export default __webpack_public_path__ + "static/media/food-presentation-4.c98484f6.jpg";